import AddonAPIService from "../addon_api_service";
import apiUtils from "../../../../core/utils/api_utils";

export default class AddonAPIServiceImpl extends AddonAPIService {
  static #instance = null;

  /**
   * Constructor
   * @returns {AddonAPIServiceImpl} - The single instance of this class
   * @description This is a singleton class. Only one instance of this class
   * can exist at any given time. If an instance already exists, this
   * constructor will simply return that instance instead of creating a new one.
   *
   * The constructor calls the parent constructor and stores the instance.
   */
  constructor() {
    if (AddonAPIServiceImpl.#instance) {
      /**
       * If an instance already exists, return that instance instead of creating a new one.
       */
      return AddonAPIServiceImpl.#instance;
    }

    /**
     * Call the parent constructor
     */
    super();

    /**
     * Store the instance
     */
    AddonAPIServiceImpl.#instance = this;
  }

  /**
   * Retrieves all active add-ons from the server
   * @returns {object} Server response data
   * @throws {object} Server error response
   */
  async getActiveAddons() {
    try {
      const response = await apiUtils.get("/api/addons/active");
      return response.data;
    } catch (error) {
      return error.response?.data || { success: false, message: "Something went wrong." };
    }
  }

  /**
   * Retrieves all add-ons from the server
   * @returns {object} Server response data
   * @throws {object} Server error response
   */
  async getAddons() {
    try {
      const response = await apiUtils.get("/api/addons");
      return response.data;
    } catch (e) {
      /**
       * If an error occurs, return the error response or a default error message
       */
      return e.response ? e.response.data : { success: false, message: "Something wen't wrong." };
    }
  }
  /**
   * Avail an add-on for the user
   * @param {object} data - The data contains the add-on id and user id
   * @returns {object} Server response data
   * @throws {object} Server error response
   */
  async availAddon(data) {
    try {
      /**
       * Post the data to the server
       */
      const response = await apiUtils.post("/api/addons/avail", data);

      return response.data;
    } catch (error) {
      /**
       * If an error occurs, return the error response or a default error message
       */
      return error.response ? error.response.data : { success: false, message: "Something went wrong." };
    }
  }

  async getAddonById(addOnId) {
    try {
      const response = await apiUtils.get(`/api/addons/${addOnId}`);
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : { success: false, message: "Something went wrong." };
    }
  }
}
